import { css } from '@emotion/react';

// 288px ≈ 6 rows.
export const ADDRESS_LIST_MAX_HEIGHT = 288;

const makeAddressListStyles = ({ theme }) => {
  const { palette, border, typography } = theme.mvf;

  return {
    messageContainer: css({
      maxWidth: 640,
      margin: '20px auto',
      textAlign: 'center',
    }),
    listContainer: css({
      maxWidth: 640,
      margin: '0 auto',
    }),
    heading: css({
      marginTop: 10,
      marginBottom: 12,
      textAlign: 'left',
      '& h6': {
        textAlign: 'left',
        fontWeight: 900,
        fontSize: 30,
        lineHeight: 1,
      },
    }),
    subheading: css({
      margin: '0 0 24px 0',
      textAlign: 'left',
      '& p': { textAlign: 'left' },
    }),
    rowScrollArea: css({
      minHeight: 0,
      maxHeight: ADDRESS_LIST_MAX_HEIGHT,
      overflowY: 'auto',
      border: 'solid',
      borderWidth: border.width.thin,
      borderColor: palette.component.answerUnselectedColor,
      borderRadius: '6px',
    }),
    selectorLabel: css({
      margin: '0 0 8px 0',
      textAlign: 'left',
      '& p': {
        textAlign: 'left',
        fontWeight: typography.weight.thick,
      },
    }),
    row: css({
      display: 'block',
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      border: 'none',
      backgroundColor: palette.background.widgetBackgroundColor,
      padding: 15,
      color: palette.text.primaryTextColor,
      fontWeight: typography.weight.thick,
      '& p': { textAlign: 'left' },
      '& + &': {
        borderTop: `${border.width.thin}px solid ${palette.component.answerUnselectedColor}`,
      },
      '&[data-stripe="even"]': {
        backgroundColor: palette.background.secondaryBackgroundColor,
      },
    }),
    rowSelected: css({
      outline: `2px solid ${palette.component.answerSelectedColor}`,
      outlineOffset: '-2px',
    }),
    continueContainer: css({
      height: 45,
      textAlign: 'center',
    }),
  };
};

export default makeAddressListStyles;
